'use client';
import type { ReactNode } from 'react';
import { useSearchParams } from 'next/navigation';

import { DynamicGameSections } from '@/widgets/game-sections/ui/dynamic-game-sections';
import type { HomeGameSectionsProps } from './home-game-sections-types';

export const HomeGameSectionsSearchSwitch = ({
  defaultContent,
  openNotAllowedModal,
}: HomeGameSectionsProps & { defaultContent: ReactNode }) => {
  const searchParams = useSearchParams();

  if (searchParams.get('search')) {
    return <DynamicGameSections openNotAllowedModal={openNotAllowedModal} />;
  }

  return defaultContent;
};
